export const DEFAULT_PAGE_NUMBER = 1
export const DEFAULT_PER_PAGE = 20
export const PER_PAGE_OPTIONS = [20, 50, 100]
